__webpack_require__.p = "/payments-donec/";